import { request } from "../../api";
import { MESSAGE } from "../../../../constants/api/message";
import { LogoSettings } from "../../../../types/logoSettings.types";

const { get } = request;
const initialRoute = "admin/employee-page-design";

export const getLogoSettingsByGroupNumber = async (group_number: number): Promise<LogoSettings> => {
	try {
		const endpoint = `${initialRoute}/logo-settings/${group_number}`;
		const response = await get(endpoint);
		// console.log("response", response);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ || message === MESSAGE.get.empty) {
				const {
					data: { result }
				} = response;
				if (result) {
					return result;
				} else {
					const logoSettings: LogoSettings = {
						logo: {
							attachment: {},
							xl: {
								height: 50,
								width: 450
							},
							lg: {
								height: 200,
								width: 100
							},
							md: {
								height: 200,
								width: 100
							},
							sm: {
								height: 200,
								width: 100
							},
							xs: {
								height: 200,
								width: 100
							}
						},
						favicon: {},
						group_number
					};
					return logoSettings;
				}
			}
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const logoSettings = {
	getLogoSettingsByGroupNumber
};
